import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { RhTenantInfo } from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'

export const TenantOperations = {
  GetAll: 'TenantOperations-GetAll',
  Add: 'TenantOperations-Add',
  Update: 'TenantOperations-Update',
  Delete: 'TenantOperations-Delete',
}

export class TenantController extends InternalAPI {
  constructor(private onRequestChange?: OnRequestChangeCallback) {
    super('/api/system/tenants')
  }

  public GetAll() {
    return this.GetAsync<RhTenantInfo[]>({
      id: TenantOperations.GetAll,
      relativePath: '/',
      onRequestChange: this.onRequestChange,
    })
  }

  public Add(tenantInfo: RhTenantInfo) {
    const data = {
      Identifier: tenantInfo.identifier,
      Name: tenantInfo.name,
      PartyId: tenantInfo.partyId,
    }

    return this.PostAsync<RhTenantInfo>({
      id: TenantOperations.Add,
      relativePath: '',
      data,
      onRequestChange: this.onRequestChange,
    })
  }

  public Update(tenantInfo: RhTenantInfo) {
    const data = {
      Name: tenantInfo.name,
      PartyId: tenantInfo.partyId,
    }

    return this.PostAsync<RhTenantInfo>({
      id: TenantOperations.Update,
      relativePath: `/${tenantInfo.id}`,
      data,
      onRequestChange: this.onRequestChange,
    })
  }

  public Delete(tenantId: string) {
    return this.DeleteAsync({
      id: TenantOperations.Delete,
      relativePath: `/${tenantId}`,
      onRequestChange: this.onRequestChange,
    })
  }
}
